import { path, prop, pipe, reject, equals } from 'ramda';

export const getFilters = prop('filters');
export const getSelectedFilter = prop('selectedFilter');
export const getFirstFrom = path(['dates', 'first', 'from']);
export const getFirstTo = path(['dates', 'first', 'to']);
export const getSecondFrom = path(['dates', 'second', 'from']);
export const getSecondTo = path(['dates', 'second', 'to']);
export const isDirty = path(['rangeFilter', 'isDirty']);
export const getFiltersForRange = pipe(
  prop('filters'),
  reject(equals('1y'))
);
